export default function safeJSONParse(str: string): unknown {
  try {
    return JSON.parse(str)
  } catch (_) {
    return str
  }
}
